import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { FastField, FieldInputProps } from 'formik';

import { selectQuery } from 'rdx/router';

import MenuItemAvailabilitySelect from '../MenuItemAvailabilitySelect';

interface AvailabilityFieldProps {
  id: number;
  showLabel?: boolean;
  disabled?: boolean;
  required?: boolean;
}

interface FieldWithModeProps extends Partial<AvailabilityFieldProps> {
  field: FieldInputProps<any>;
}

const FieldWithMode: React.FC<FieldWithModeProps> = ({ field, ...inputFieldProps }) => {
  const intl = useIntl();
  const query = useSelector(selectQuery);
  return query.mode === 'edit' ? (
    <MenuItemAvailabilitySelect
      {...inputFieldProps}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
    />
  ) : (
    <Box
      py={0.5}
      px={1}
      width={150}
      display="flex"
      justifyContent="center"
      sx={{ border: 'solid 1px', borderColor: 'colors.neutral400', borderRadius: '100px' }}
    >
      <Typography variant="bodyS">
        {intl.formatMessage({ id: `widgets.MenuEditor.${field.value}` })}
      </Typography>
    </Box>
  );
};

const AvailabilityField: React.FC<AvailabilityFieldProps> = ({
  id,
  showLabel,
  ...inputFieldProps
}) => {
  const intl = useIntl();
  const shouldShowLabel = showLabel;

  return (
    <Box>
      {shouldShowLabel ? (
        <Typography variant="bodyM" color="textSecondary">
          {intl.formatMessage({ id: 'widgets.MenuEditor.availabilitySubttile' })}
        </Typography>
      ) : null}

      <FastField name={`items[${id}].availability`}>
        {({ field }: { field: FieldInputProps<any> }) => {
          return <FieldWithMode field={field} {...inputFieldProps} />;
        }}
      </FastField>
    </Box>
  );
};

export default memo(AvailabilityField);
